'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'book-bookmark';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e0bb';
var svgPathData = ['M16 16l0 405.7C27.7 408.4 44.9 400 64 400l368 0 0-384-80 0 0 208c-2.7-1.6-29.3-17.6-80-48-50.7 30.4-77.3 46.4-80 48l0-208-176 0z', 'M0 0l448 0 0 416-32 0 0 80 32 0 0 16-448 0 0-512zM336 16l-128 0 0 179.7 55.8-33.5 8.2-4.9 8.2 4.9 55.8 33.5 0-179.7zM192 16L16 16 16 421.7C27.7 408.4 44.9 400 64 400l368 0 0-384-80 0 0 208c-2.7-1.6-29.3-17.6-80-48-50.7 30.4-77.3 46.4-80 48l0-208zM64 416c-26.5 0-48 21.5-48 48l0 32 384 0 0-80-336 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;